import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useParams } from "react-router-dom";
import Button from "../components/Button";
import Container from "../components/Container";
import Header from "../components/Header";
import LargePinkErrorIcon from "../components/icons/LargePinkErrorIcon";
import RippleLoader from "../components/RippleLoader";
import TariffPreview from "../components/SwitchStatus/TariffPreview";
import { STATUS_ICONS, STATUSES } from "../constants/switchStatus";
import { useSwitch } from "../context/SwitchContext";
import EN from "../locales/en.json";

const SwitchStatus = () => {
  const { switchId } = useParams();
  const [fetchingSwitchStatus, setFetchingSwitchStatus] = useState(false);
  const [switchStatus, setSwitchStatus] = useState(STATUSES.AWAITING_EXPORT);
  const [switchError, setSwitchError] = useState(false);
  const [tariff, setTariff] = useState(null);
  const { getSwitchStatus } = useSwitch();
  const copy = EN.switch_status;
  const statusCopy = EN.switch_status[switchStatus];

  const fetchSwitchStatus = async () => {
    setFetchingSwitchStatus(true);
    setSwitchError(false);
    try {
      const status = await getSwitchStatus(switchId);
      if (status) {
        if (status?.switchStatus === STATUSES.SUPPLIER_API_REQUEST_ERROR) {
          setSwitchError(true);
        }
        setSwitchStatus(status?.switchStatus);
        setTariff(status?.details);
      } else {
        setSwitchError(true);
      }
    } catch (error) {
      setSwitchError(true);
    }
    setFetchingSwitchStatus(false);
  };

  useEffect(() => {
    fetchSwitchStatus();
  }, []);

  if (fetchingSwitchStatus) {
    return (
      <Container>
        <RippleLoader />
      </Container>
    );
  }

  return (
    <Container>
      {!switchError ? (
        <>
          <Header title={statusCopy?.title} />

          {STATUS_ICONS[switchStatus] ? (
            STATUS_ICONS[switchStatus]
          ) : (
            <LargePinkErrorIcon />
          )}

          <h3 className="mt-4 max-w-4xl text-md leading-[1.5] text-center">
            {statusCopy?.subtitle}
          </h3>

          <hr className="border-[#afb6b9] mt-4 mb-6" />

          <div>
            <h2 className="text-[30px] font-bold leading-[1.2] text-primary mb-4">
              {copy.new_tariff_title}
            </h2>

            {tariff && <TariffPreview tariff={tariff} />}

            <ReactMarkdown className="markdown my-6">
              {statusCopy?.outro_markdown_text}
            </ReactMarkdown>

            <Button as="anchor" to="https://loop.homes" fullWidth>
              Not signed up to Loop? Find out more
            </Button>
          </div>
        </>
      ) : (
        <div>
          <Header title="Something went wrong" />

          <LargePinkErrorIcon />

          <p className="text-center my-6">
            There's been an error while processing your request.
          </p>

          <div>
            <Button onClick={fetchSwitchStatus} fullWidth>
              Try again
            </Button>
            <div className="flex items-center gap-4 my-4">
              <hr className="border-[#afb6b9] flex-1" />
              <span className="flex-shrink-0">or</span>
              <hr className="border-[#afb6b9] flex-1" />
            </div>
            <Button
              as="anchor"
              to="https://kb.loop.homes/kb-tickets/new"
              target="_blank"
              variant="secondary"
              fullWidth
            >
              Contact Loop Support
            </Button>
          </div>
        </div>
      )}
    </Container>
  );
};

export default SwitchStatus;
